import { Link, useLocation } from 'react-router-dom';
import { Flag } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useApp } from '../AppProvider.tsx';
import useAppLocation from '../useAppLocation.ts';
import type { NavLinkProps } from '@fastnorth/kraken/components/navigation';

const useHomeLink = (): NavLinkProps => {
  const { t } = useTranslation('translation', { keyPrefix: 'karwa.components.navigation' });
  const [{ event }] = useApp();
  const { uniqueCode } = event || {};
  const { search } = useLocation();
  const { isHome } = useAppLocation();

  return {
    id: 'home',
    active: isHome,
    children: (
      <Link
        to={`/events/${uniqueCode}${search}`}
        className={'flex items-center'}
        data-dd-action-name={'link-home-nav_menu'}>
        <Flag size={16} strokeWidth={2} className={'mr-4'} />
        {t('home_label')}
      </Link>
    ),
  };
};

export default useHomeLink;
